// Formerly an inline <script> in public/index.html. Moved into the bundle so the
// CSP can drop 'unsafe-inline' from scripts. Loads Microsoft Clarity; the injected
// tag points at https://www.clarity.ms which is allowlisted in the CSP.
export function loadClarity() {
	if (typeof window === 'undefined') return;
	(function (c, l, a, r, i, t, y) {
		c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
		t = l.createElement(r); t.async = 1; t.src = 'https://www.clarity.ms/tag/' + i;
		y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
	})(window, document, 'clarity', 'script', 'i8rz9zmeam');
}
